import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SharedModule } from './shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DecimalPipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { LoginComponent } from './auth/login/login.component';
import { httpInterceptorProviders } from './shared/interceptors';
import { WebenquiryformComponent } from './webenquiryform/webenquiryform.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { WebenquiryEcommerceformComponent } from './webenquiry-ecommerceform/webenquiry-ecommerceform.component';
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    WebenquiryformComponent,
    ForgotPasswordComponent,
    WebenquiryEcommerceformComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    BsDatepickerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
      provide: TranslateLoader,
      useFactory: HttpLoaderFactory,
      deps: [HttpClient]
        }
      }),
  ],
  providers: [DecimalPipe, httpInterceptorProviders],
  bootstrap: [AppComponent]
}

) export class AppModule { }